import { useQuery } from '@tanstack/react-query';
import { getPatientById } from 'api/auth.api';

export const useGetPatientById = (id) => {
  return useQuery({
    queryKey: ['patientById', id],
    queryFn: () => getPatientById(id),
    enabled: !!id,
  });
};
